import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import { ResidentAppCard, ResidentAppView } from '@pandiafi/components'

import { DataLoader } from './FrontPageViewDataLoader'
import { BulletinsList } from './components/BulletinsList'

import { ResidentNotifications, TaskLinks, PendingOperations } from 'components'
import DefectNotices from 'components/DefectNotices'

export const FrontPageView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'frontPage'])

  const welcomeText = (firstName: string | null) =>
    `${t('common:hi')} ${firstName}!`

  return (
    <TitleController title={t('titles:home')}>
      <DataLoader>
        {({ user, contract, featureFlags, bulletins, hasMoreBulletins }) => (
          <ResidentAppView
            title={welcomeText(user.firstName)}
            mobileBackdrop
            aside={
              <>
                <DefectNotices />
                <PendingOperations />
                <ResidentNotifications contractType={contract.contractType} />
                <TaskLinks featureFlags={featureFlags} contract={contract} />
              </>
            }
          >
            <ResidentAppCard title={t('frontPage:header')}>
              <BulletinsList
                bulletins={bulletins}
                hasMoreBulletins={hasMoreBulletins}
              />
            </ResidentAppCard>
          </ResidentAppView>
        )}
      </DataLoader>
    </TitleController>
  )
}
